import classNames from 'classnames';
import startCase from 'lodash/startCase';

import styles from './ProfileBadge.module.css';

type BadgeTone = 'high' | 'medium' | 'low' | 'neutral';

const getTone = (value: string): BadgeTone => {
  const normalized = value.toLowerCase();
  if (normalized.includes('high')) return 'high';
  if (normalized.includes('medium') || normalized.includes('moderate')) {
    return 'medium';
  }
  if (normalized.includes('low')) return 'low';
  return 'neutral';
};

/**
 * Prestige / flight-risk / company-prestige badge used by the Dashboard 2026
 * profile popout (FullProfileInfo).
 */
export const ProfileBadge = ({ value }: { value: string }) => {
  const tone = getTone(value);
  return (
    <span className={classNames(styles.badge, styles[tone])}>
      {startCase(value)}
    </span>
  );
};
